/*eslint-disable */
export default function useMixin() {
  const numberFormat = number => number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  const isInt = number => Number(number) === number && number % 1 === 0

  const toFixed = (number, decimals) => {
    const x = 10 ** Number(decimals) + 1
    return (Number(number) + 1 / x).toFixed(decimals)
  }

  const getUuid = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    )

  const createFile = (bits, name, options) => {
    try {
      // If this fails, we go for Blob
      return new File(bits, name, options)
    } catch (e) {
      // If we're here a new File could not be constructed
      const myBlob = new Blob(bits, options || {})
      myBlob.lastModified = new Date()
      myBlob.name = name
      return myBlob
    }
  }

  const shortenText = (str, limit) => {
    let bits, i
    bits = str.split('')
    if (bits.length > limit) {
      for (i = bits.length - 1; i > -1; --i) {
        if (i > limit) {
          bits.length = i
        } else if (bits[i] === ' ') {
          bits.length = i
          break
        }
      }
      bits.push('...')
    }
    return bits.join('')
  }

  const parseMapping = (mappings, getOnlyIds = false) => {
    const mapps = []

    mappings.forEach(value => {
      if (getOnlyIds) {
        mapps.push(value.id)
      } else {
        const title =
          value.country_flag === null || value.country_flag === ''
            ? value.name
            : value.name + ' / ' + value.country_name
        mapps.push(title)
      }
    })

    return getOnlyIds ? mapps : mapps.join(', ')
  }

  const copyFn = str => {
    var dummy = document.createElement('input')
    dummy.style.position = 'fixed'
    dummy.style.opacity = 0
    dummy.style.zIndex = -1

    document.body.appendChild(dummy)
    dummy.setAttribute('value', str)
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
  }

  return {
    createFile,
    numberFormat,
    getUuid,
    parseMapping,
    toFixed,
    isInt,
    shortenText,
    copyFn,
  }
}
